// extracted by mini-css-extract-plugin
export default {"root":"PriceBadge_root__-WR9d","priceText":"PriceBadge_priceText__iz1lx"};